import React from 'react';
import { ChevronRightIcon } from '@common/components/icons';
import * as styles from '../EntityPanelSelector.module.css';

/**
 * PanelArrow Component
 * Renders the arrow between panels
 */
function PanelArrow() {
  return (
    <div className={styles.arrowContainer}>
      <div className={styles.arrowButton}>
        <ChevronRightIcon />
      </div>
    </div>
  );
}

export default PanelArrow;

